import React, { ComponentType, Suspense, createElement } from 'react';
import type { SwipeableDrawerProps } from '@mui/material';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { ModalContainer, ModalLayout, ModalLayoutTokens } from '@cp/ds/src/components/modalLayout';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { IModalWrapperProps } from './modal.interface';

export interface IDrawerModalProps extends IModalWrapperProps, Pick<SwipeableDrawerProps, 'anchor'> {}
export const DrawerModal: React.FC<IDrawerModalProps> = ({
  ContentComponent,
  contentProps,
  anchor = 'bottom',
  open,
  onClose,
  onClosed,
}) => {
  return (
    <SwipeableDrawer
      PaperProps={{
        sx: {
          borderTopLeftRadius: ModalLayoutTokens.Radius(),
          borderTopRightRadius: ModalLayoutTokens.Radius(),
          overflow: 'visible',
          backfaceVisibility: 'hidden',
        },
      }}
      SlideProps={{ onExited: onClosed }}
      anchor={anchor}
      onClose={onClose}
      onOpen={console.debug}
      open={open}
      sx={{ zIndex: 50 }}
      transitionDuration={300}
      variant="temporary"
    >
      <Suspense
        fallback={
          <ModalLayout>
            <ModalContainer>
              <ContentSkeleton blocks={2} />
            </ModalContainer>
          </ModalLayout>
        }
      >
        <ContentComponent {...contentProps} />
      </Suspense>
    </SwipeableDrawer>
  );
};

export const withAnchor = (Drawer: ComponentType<IDrawerModalProps>, anchor: 'right' | 'bottom') => (props: IModalWrapperProps) =>
  createElement(Drawer, { ...props, anchor });
